import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { MESSAGE_TYPES, SENDER } from '@/features/reports/constants';
import lodashSet from 'lodash/set';

const leftPanelInitialState = () => ({
  leftPanel: {
    isOpen: false,
    id: null,
    kdSearch: '',
    columnsSearch: '',
    kdFilter: 'all',
  },
});

const rightPanelInitialState = () => ({
  rightPanel: {
    id: null,
    drilldownChat: {
      fetchDefaultDrilldowns: true,
      history: [
        {
          sender: SENDER.SYSTEM,
          messageType: MESSAGE_TYPES.DRILLDOWN_WELCOME,
          loading: true,
        },
        {
          sender: SENDER.SYSTEM,
          messageType: MESSAGE_TYPES.SUGGESTED_DRILLDOWNS,
          loading: true,
        },
      ],
      addedMsg: '',
      syncState: false,
    },
    addColumnChat: {
      history: [
        {
          sender: SENDER.SYSTEM,
          messageType: MESSAGE_TYPES.ADD_COLUMN_WELCOME,
        },
        {
          sender: SENDER.SYSTEM,
          messageType: MESSAGE_TYPES.EXPLORE_COLUMNS,
        },
      ],
      orderId: null,
      selectedColumn: null,
    },
    event: null,
  },
});

const resultsPageInitialState = () => ({
  resultsPage: {
    inputValue: '',
    loading: false,
    showReachOutChat: false,
    firstQuerySearch: true,
  },
});

const messagesInitialState = () => ({
  messages: {
    processingMessage: {},
    fetchMessageHistory: true,
    loading: {
      initialize: false,
      processing: false,
      fetching: false,
    },
    currentMessageId: '',
    showClarification: false,
    kdUsed: [],
    currentConversationId: '',
    table: {
      calculatedColumn: {
        showViewDetails: false,
        name: '',
        description: '',
        formula: '',
        sourcesUsed: [],
      },
    },
    event: null,
    willImpactTable: false,
    hasGroupBy: false,
    alert: {
      dashboardDrilldown: {
        show: false,
        widgetName: '',
      },
    },
  },
  charts: {
    suggestionsSearch: '',
    messageId: '',
    stepId: 1,
  },
  shareReport: {
    isOpen: false,
    type: '',
  },
  agenticChat: {
    isOpen: false,
    messageId: '',
  },
});

export default create()(
  immer((set) => ({
    ...leftPanelInitialState(),
    ...rightPanelInitialState(),
    ...messagesInitialState(),
    ...resultsPageInitialState(),
    setLeftPanelState: (key, value) =>
      set((state) => {
        state.leftPanel[key] = value;
      }),
    setRightPanelState: (key, value) =>
      set((state) => {
        lodashSet(state.rightPanel, key, value);
      }),
    setMessagesState: (key, value) =>
      set((state) => {
        lodashSet(state.messages, key, value);
      }),
    setMessagesTableState: (key, value) =>
      set((state) => {
        lodashSet(state.messages, key, value);
      }),
    setMessagesLoadingState: (key, value) =>
      set((state) => {
        state.messages.loading[key] = value;
      }),
    setResultsPageState: (key, value) =>
      set((state) => {
        state.resultsPage[key] = value;
      }),
    setChartsSuggestionsSearch: (keyword) =>
      set((state) => {
        state.charts.suggestionsSearch = keyword;
      }),
    setChartsMessageId: (messageId) =>
      set((state) => {
        state.charts.messageId = messageId;
      }),
    setChartsStepId: (stepId) =>
      set((state) => {
        state.charts.stepId = stepId;
      }),
    setShareReport: (isOpen, type) =>
      set((state) => {
        state.shareReport.isOpen = isOpen;
        state.shareReport.type = type || state.shareReport.type;
      }),
    setAgenticChat: (key, value) =>
      set((state) => {
        state.agenticChat[key] = value;
      }),
    resetLeftPanelState: () =>
      set(() => ({
        ...leftPanelInitialState(),
      })),
    resetMessagesState: () =>
      set(() => ({
        ...messagesInitialState(),
      })),
    resetResultsPageState: () =>
      set(() => ({
        ...resultsPageInitialState(),
      })),
    resetRightPanelState: () =>
      set(() => ({
        ...rightPanelInitialState(),
      })),
  }))
);
